import React from "react";
import Assessment from "../Assessment/Assessment";

export default class AssessmentLauncher extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible:
        typeof this.props.visible !== "undefined" ? this.props.visible : false,
    };

    this.onHide = this.onHide.bind(this);
    this.onShow = this.onShow.bind(this);
  }

  render() {
    // console.log('AssessmentLaunchButton', this.props);
    const ua = this.props.user_assessment.data || {};

    return (
      <div className="AssessmentLaunchButton text-center">
        <button type="button" className="btn btn-primary" onClick={this.onShow}>
          {this.props.buttonTitle || ua.title}
        </button>
        <Assessment
          {...ua}
          course={this.props.course}
          entries={ua.entries}
          template_id={this.props.user_assessment.template_id}
          display_mode={this.props.display_mode}
          success_page={this.props.success_page}
          get_assessment_path={this.props.get_assessment_path}
          assessment_respond_path={this.props.assessment_respond_path}
          visible={this.state.visible}
          onHide={this.onHide}
          ref="assessment"
          hideButtons={this.props.hide_buttons}
        />
      </div>
    );
  }

  onHide(e) {
    if (typeof this.props.onHide === "function") {
      this.props.onHide();
    } else {
      window.location.reload();
    }
  }

  onShow(e) {
    if (typeof this.props.onShow === "function") {
      this.props.onShow();
    }

    this.setState({ visible: true }, () => {
      $("body").css({ overflow: "hidden" });
    });
  }
}
